import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b996c9d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b996c9d')) {
      api.createRecord('7b996c9d', component.options)
    } else {
      api.reload('7b996c9d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7b996c9d", function () {
      api.rerender('7b996c9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/langSelect/index.vue"
export default component.exports